var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharterFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.25 50.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.83 1.5a3.68 3.68 0 0 0-2.44.93L21 17.37h10.75L42.28 8a3.69 3.69 0 0 0-2.45-6.5M3.5 13.88v21.74m-2-11.12h3.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.39 29.24 26.61-7v-1.5h3.12a1.63 1.63 0 0 0 1.63-1.63h0a1.63 1.63 0 0 0-1.63-1.62H63l-.13-10.74h-4a6.35 6.35 0 0 0-6.37 6.45l.12 4.3h-8.1a3.75 3.75 0 0 0-4.44-.18l-26.46.18a6.75 6.75 0 0 0-6.75 6.75h0A6.75 6.75 0 0 0 13.62 31l17.63.37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.37,
    cy: 36.75,
    r: 4.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.15 48.75a3.7 3.7 0 0 1-2.45-.93L23.5 23.75h11.12l21 18.55a3.69 3.69 0 0 1-2.47 6.45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharterFlight);
export default __webpack_public_path__ + "static/media/charterFlight.7eb5597a0e178fff7b0cd409208ef8f5.svg";
export { ForwardRef as ReactComponent };